import { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import Container from 'react-bootstrap/Container';
import { useNavigate } from 'react-router-dom';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {ButtonWithSound, CheckmarkWithSound} from '../Button/Button';
import './Intro.scss';

const Intro = (props) => {
    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const { freeplay } = useSelector((state) => state.freeplay, shallowEqual);
    const dispatch = useDispatch();
    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;
    const navigate = useNavigate();

    const isIOS = () => {
        return [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      }

    const [example, setExample] = useState(false);
    const [main, setMain] = useState(true);
    const [chooseStudentCharacter, setChooseStudentCharacter] = useState(false);
    const [chooseFriendCharacter, setChooseFriendCharacter] = useState(false);
    const [selectedStudentCharacter, setSelectedStudentCharacter] = useState(null)
    const [selectedFriendCharacter, setSelectedFriendCharacter] = useState(null)
    const [studentName, setStudentNameLocal] = useState('')
    const [friendName, setFriendNameLocal] = useState('')
    const [audioDone, setAudioDone] = useState(isIOS() ? true : false);

    const coin = generateImageUrl('images/Images/Coin_Empty.png');
    const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png')
    const Instructions = generateImageUrl('media/Freeplay/choose_intro.m4a')
    let initCharacters = [
        { name: 'crab', src: 'images/newDesign/FreePlay/level2/crabIcon.svg', full: 'images/newDesign/FreePlay/character/Crab.svg'},
        { name: 'dog', src: 'images/newDesign/FreePlay/level2/dogIcon.svg', full: 'images/newDesign/FreePlay/character/Dog.svg'},
        { name: 'lizard', src: 'images/newDesign/FreePlay/level2/lizzardIcon.svg', full: 'images/newDesign/FreePlay/character/Lizard.svg'},
        { name: 'monkey', src: 'images/newDesign/FreePlay/level2/monkeyIcon.svg', full: 'images/newDesign/FreePlay/character/Monkey.svg'},
        { name: 'bird', src: 'images/newDesign/FreePlay/level2/birdIcon.svg', full: 'images/newDesign/FreePlay/character/Bird.svg'},
    ]

    const [characters, setCharacters] = useState(initCharacters);


    const comnfirmCharacter = (name) => {
        setCharacters(prev => prev.filter(charater => charater.name !== name))
        if(selectedStudentCharacter && selectedFriendCharacter){
            dispatch({ type: 'FREEPLAY_SET_SELECTED_FRIEND_CHARACTER', payload: selectedFriendCharacter });
            props.finish();
        }
        else{
            dispatch({ type: 'FREEPLAY_SET_SELECTED_STUDENT_CHARACTER', payload: selectedStudentCharacter });
            setChooseStudentCharacter(false)
            setChooseFriendCharacter(true);
        }
    }


    return (
        <div className='introBody'>
            {main && <div className='mainPage'>
                <audio autoPlay onEnded={() => setAudioDone(true)}>
                    <source src={Instructions}></source>
                </audio>
                <div className='info'>
                    <Container>
                        <h2 >Partner Up for Practice!</h2>
                        <h4 >Choose a friend to sit next to you and share your device to practice what you’ve learned.</h4>
                        <h4 >This person can be a:</h4>
                        <h4 >Friend, Classmate, Teacher, Aide, or Family Member.</h4>
                    </Container>
                </div>
                <h2 className='first'></h2>
                {/* <h2 className='first'>Is this your friend's first time?</h2> */}
                {audioDone && <div className='infoButton'>
                    <Container>
                        <Row xs={1}>
                            {/* <Col> 
                                <div className='button yes' onClick={() => {setExample(true); setMain(false);}}>
                                    <div className='text'>Yes</div>
                                </div>
                                <p>Watch the instruction video</p>                 
                            </Col> */}
                            <Col> 
                                <ButtonWithSound label="I am sitting by my friend" className='button yes' onClick={() => {setChooseStudentCharacter(true); setMain(false);}}>
                                </ButtonWithSound>
                                {/* <p>Skip video</p>                  */}
                            </Col> 
                        </Row>
                    </Container>
                </div>}
            </div>}
            {example && (
                <CloudfrontVideoFormat
                source={'ae17b215c914c6dd97c61e0c9b76/480.m3u8'}
                close={() => {
                    setExample(false);
                    setMain(true);
                }}
                ended={() => {
                    setExample(false);
                    setMain(true);
                }}
            />)}
            {chooseStudentCharacter && <div className="character-selector">
                <audio autoPlay>
                    <source src={generateImageUrl('media/Freeplay/level4/intro/intro_choose_character_name.mp3')} type="audio/mp3"/>
                </audio>
                <h1 className="title">Choose Your Character and Enter Your Name</h1>
                <div className="content">
                    <div className="avatar">
                        <div className="avatar-inner">
                            {selectedStudentCharacter ? <img alt="seleted avatar" src={generateImageUrl(selectedStudentCharacter.src)}/> : ''}
                        </div>
                        <div className="character-name">
                            <input
                                type="text"
                                placeholder="Your Name"
                                value={freeplay.studentName}
                                onChange={(e) => dispatch({ type: 'FREEPLAY_SET_STUDENT_NAME', payload: e.target.value })}
                                className="name-input"
                            />
                        </div>
                    </div>
                    <div className="character-buttons">
                        {characters.map((character) => (
                            <div key={character.name} className="character-button">
                                <img
                                    alt="seleted avatar"
                                    key={character.name}
                                    src={generateImageUrl(character.src)}
                                    onClick={() => setSelectedStudentCharacter(character)}
                                    aria-label={`Select ${character.name}`}
                                />
                            </div>
                        ))}
                    </div>
                    {selectedStudentCharacter && freeplay.studentName.length > 0 && <CheckmarkWithSound className='checkMark' onClick={() => comnfirmCharacter(selectedStudentCharacter.name)} img={greenCheck} />}
                </div>
            </div>}
            {chooseFriendCharacter && <div className="character-selector">
                <audio autoPlay>
                    <source src={generateImageUrl('media/Freeplay/level4/intro/intro_choose_friend_name.mp3')} type="audio/mp3"/>
                </audio>
                <h1 className="title">Choose Your Character and Enter Your Friend’s Name</h1>
                
                <div className="content">
                    <div className="avatar">
                        <div className="avatar-inner">
                            {selectedFriendCharacter ? <img alt="seleted avatar" src={generateImageUrl(selectedFriendCharacter.src)}/> : ''}
                        </div>
                        <div className="character-name">
                            <input
                                type="text"
                                placeholder="Friend’s Name"
                                value={freeplay.friendName}
                                onChange={(e) => dispatch({ type: 'FREEPLAY_SET_FRIEND_NAME', payload: e.target.value })}
                                className="name-input"
                            />
                        </div>
                    </div>
                    <div className="character-buttons">
                        {characters.map((character) => (
                            <div key={character.name} className="character-button">
                                <img
                                    alt="seleted avatar"
                                    key={character.name}
                                    src={generateImageUrl(character.src)}
                                    onClick={() => setSelectedFriendCharacter(character)}
                                    aria-label={`Select ${character.name}`}
                                />
                            </div>
                        ))}
                    </div>
                    {selectedFriendCharacter && freeplay.friendName.length > 0 && <CheckmarkWithSound className='checkMark' onClick={() => comnfirmCharacter(selectedFriendCharacter.name)} img={greenCheck} />}
                </div>
            </div>}
        </div>
    );
};
export default Intro;
